import React from 'react';
import { Helmet } from 'react-helmet-async';

const DESCRIPTION = 'Trying to find a station with gas? Help others in your area by telling us if a station you visited is open, closed, or out of fuel.';
const THUMBNAIL = 'https://images.gasbuddy.com/images/websites/gasbuddy/apps/cellphone-app.png';
const TITLE = 'GasBuddy Gasoline Availability Tracker';

export default function DefaultHelmet() {
  return (
    <Helmet>
      <title>{TITLE}</title>
      <meta name="description" property="description" content={DESCRIPTION} />
      <meta name="og:type" property="og:type" content="website" />
      <meta name="og:title" property="og:title" content={TITLE} />
      <meta name="og:image" property="og:image" content={THUMBNAIL} />
      <meta name="og:description" property="og:description" content={DESCRIPTION} />
      <meta name="twitter:title" property="twitter:title" content={TITLE} />
      <meta name="twitter:image" property="twitter:image" content={THUMBNAIL} />
      <meta name="twitter:description" property="twitter:description" content={DESCRIPTION} />
      <link rel="canonical" href="https://tracker.gasbuddy.com" />
    </Helmet>
  );
}
